import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PaginationElement, PaginationList } from '../SortAndPagination.css';
import PaginationLastElement from './PaginationLastElement';
import { generatePagesNumbers } from '../../../../components_mobile/components/PaginationButtons/pagination_buttons_helper';

class PaginationElements extends Component {
  buildEllipsis() {
    return (
      <PaginationElement>
        <span>...</span>
      </PaginationElement>
    );
  }

  render() {
    const { handleClick } = this.props;
    const currentPage = Math.floor(this.props.paginationOffset / this.props.pageSize) + 1;
    const totalPages = Math.ceil(this.props.totalProducts / this.props.pageSize);
    if (totalPages < 2) {
      return null;
    }
    return (
      <PaginationList>
        <PaginationElement active={currentPage === 1}>
          <a data-cy={`link-pagination-${currentPage === 1 ? 'current' : '1'}`} onClick={handleClick}>
            1
          </a>
        </PaginationElement>
        {currentPage < 6 ? null : this.buildEllipsis()}
        {generatePagesNumbers(currentPage, totalPages).map(page => (
          <PaginationElement key={`page_element_${page}`} active={currentPage === page}>
            <a data-cy={`link-pagination-${currentPage === page ? 'current' : page}`} onClick={handleClick}>
              {page}
            </a>
          </PaginationElement>
        ))}

        {currentPage <= totalPages - 4 && totalPages > 5 ? this.buildEllipsis() : null}
        <PaginationLastElement active={currentPage === totalPages} handleClick={handleClick} totalPages={totalPages} />
      </PaginationList>
    );
  }
}

PaginationElements.propTypes = {
  handleClick: PropTypes.func.isRequired,
  pageSize: PropTypes.number.isRequired,
  paginationOffset: PropTypes.number.isRequired,
  totalProducts: PropTypes.number.isRequired
};

export default PaginationElements;
